import React from "react";
import { PublicNav, PublicFooter } from "@/components/PublicChrome";
import FaqList from "@/components/FaqList";

export default function Faq() {
  return (
    <div className="min-h-screen bg-cream font-body" data-testid="public-faq-page">
      <PublicNav />
      <section className="max-w-3xl mx-auto px-5 md:px-8 pt-16 pb-6 text-left">
        <span className="label-caps text-coral">Oral care, answered</span>
        <h1 className="text-4xl md:text-5xl font-bold text-brand tracking-tight mt-3">
          Frequently asked questions
        </h1>
        <p className="text-lg text-muted-foreground mt-4">
          Need an answer in a hurry? Every question gives you a quick answer straight away,
          with the full explanation one tap behind it.
        </p>
      </section>
      <section className="max-w-3xl mx-auto px-5 md:px-8 pb-16">
        <FaqList />
      </section>
      <PublicFooter />
    </div>
  );
}
